import React from "react";
import Select from "react-select";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import NoSsr from "@material-ui/core/NoSsr";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import PropTypes from "prop-types";

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 20,
    marginTop: `12px`,
    opacity: 1,

  },
  input: {
    display: "flex",
    padding: 0,
    opacity: 1,
    height: "auto"
  },
  valueContainer: {
    display: "flex",
    // flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: 'nowrap',
    
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
    opacity: 1
    
  },
  placeholder: {
    position: "absolute",
    left: 2,
    bottom: 6,
    fontSize: 16
  },
  paper: {
    position: "absolute",
    zIndex: 999,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0
  },
  divider: {
    height: theme.spacing.unit * 2
  }
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

NoOptionsMessage.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired
};

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

// inputComponent.propTypes = {
//   inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
// };

// function Control(props) {
//   const {
//     children,
//     innerProps,
//     innerRef,
//     selectProps: { classes, TextFieldProps }
//   } = props;

//   return (
//     <TextField
//       fullWidth
//       InputProps={{
//         inputComponent,
//         inputProps: {
//           className: classes.input,
//           ref: innerRef,
//           children,
//           ...innerProps
//         }
//       }}
//       {...TextFieldProps}
//     />
//   );
// }

function Control(props) {
  return (
      <TextField
          fullWidth
          InputProps={{
              inputComponent,
              inputProps: {
                  className: props.selectProps.classes.input,
                  inputRef: props.innerRef,
                  children: props.children,
                  ...props.innerProps,
              },
          }}
          {...props.selectProps.textFieldProps}
      />
  );
}

// Control.propTypes = {
//   children: PropTypes.node,
//   innerProps: PropTypes.object,
//   innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
//   selectProps: PropTypes.object.isRequired
// };

// function Option(props) {
//   return (
//     <MenuItem
//       ref={props.innerRef}
//       selected={props.isFocused}
//       component="div"
//       style={{
//         fontWeight: props.isSelected ? 500 : 400
//       }}
//       {...props.innerProps}
//     >
//       {props.children}
//     </MenuItem>
//   );
// }

function Option(props ) {
  return (
      <MenuItem
          buttonRef={props.innerRef}
          selected={props.isFocused}
          component="div"
          style={{
              fontWeight: props.isSelected ? 500 : 400,
          }}
          {...props.innerProps}
      >
          {props.children}
      </MenuItem>
  );
}

// Option.propTypes = {
//   children: PropTypes.node,
//   innerProps: PropTypes.object,
//   innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
//   isFocused: PropTypes.bool,
//   isSelected: PropTypes.bool
// };

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

// Placeholder.propTypes = {
//   children: PropTypes.node,
//   innerProps: PropTypes.object,
//   selectProps: PropTypes.object.isRequired
// };

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

// SingleValue.propTypes = {
//   children: PropTypes.node,
//   innerProps: PropTypes.object,
//   selectProps: PropTypes.object.isRequired
// };

function ValueContainer(props) {
  return (
    <div className={props.selectProps.classes.valueContainer}>
      {props.children}
    </div>
  );
}

// ValueContainer.propTypes = {
//   children: PropTypes.node,
//   selectProps: PropTypes.object.isRequired
// };

function Menu(props) {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

// Menu.propTypes = {
//   children: PropTypes.node,
//   innerProps: PropTypes.object,
//   selectProps: PropTypes.object
// };

const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
};

function AutocompleteReactSelect({
  options,
  selectedOption,
  handleSelectChange,
  selectLabel,
  disabled,
  name,
  classes,
  theme
}) {
  
  const [single] = React.useState(selectedOption);
  
  const selectStyles = {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      "& input": {
        font: "inherit"
      }
    })
  };

  return (
    <div className={classes.root}>
      <NoSsr>
        <Select
          name={name}
          classes={classes}
          styles={selectStyles}
          inputId="react-select-single"
          TextFieldProps={{
            label: `${selectLabel}`,
            InputLabelProps: {
              htmlFor: "react-select-single",
              shrink: true
            },
            placeholder: "Search"
          }}
          options={options}
          components={components}
          value={single}
          onChange={(e, name) => handleSelectChange(e, name)}
          isDisabled={disabled}
        />
      </NoSsr>
    </div>
  );
}


AutocompleteReactSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles,{ withTheme: true })(AutocompleteReactSelect);



// WEBPACK FOOTER //
// ./src/utils/AutocompleteSelect.js